<template>
  <div class="full">
    <div class="action-tools">
      <span class="action-icon" @click="$emit('view', 'main')">Close</span>
      <span id="undo" ref="undoElement" class="action-icon" @click="undo">Undo</span>
      <span id="redo" ref="redoElement" class="action-icon" @click="redo">Redo</span>
      <span id="clear" ref="clearElement" class="action-icon" @click="clear">Clear</span>
      <span id="clear" ref="clearElement" class="action-icon" @click="done">Done</span>
      <!-- <span id="wrap" class="action-icon" @click="wrapText">Add Text</span>
      <span id="wrap" class="action-icon" @click="breakLatex">Breakline</span> -->
      <textarea v-model="latex" type="text" placeholder="LaTeX Script Box" class="latex-text" @input="onInput" />
    </div>
    <div class="latex">
      <Latex style="height: 20px;" :latex="output"></Latex>
      <!-- <div id="editor-output" ref="mathJaxEl" v-html="output" /> -->
    </div>

    <!-- <vue-mathjax v-if="formula" :formula="formula"></vue-mathjax> -->
    <div ref="editordom" class="writing-container" touch-action="none">
      <div class="loader" v-if="!reff.ready">
        Pre-Loading....
      </div>
    </div>
  </div>
</template>

<script>
import Latex from '../yoqb-compos/Latex.vue'
import * as MyScriptJS from 'myscript'
// import 'myscript/dist/myscript.min.css'
// import * as mathjax from 'mathjax'
// import { VueMathjax } from 'vue-mathjax'

let reff = {
  ready: false
}

export const preload = () => {
  if (reff.ready) {
    return Promise.resolve()
  }
  let wrapp = document.createElement('div')
  let preloader = document.createElement('div')
  preloader.style.cssText = `
    width: 100%;
    height: 100%;
  `
  wrapp.className = 'writing-container'
  wrapp.style.cssText =  `
    position: fixed;
    z-index: -1;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    opacity: 0;
  `
  wrapp.appendChild(preloader)
  document.body.appendChild(wrapp)

  MyScriptJS.register(preloader, {
    recognitionParams: {
      type: 'MATH',
      protocol: 'WEBSOCKET',
      apiVersion: 'V4',
      server: {
        applicationKey: 'f32bc325-1a44-4b36-b65e-195eb9f795b6',
        hmacKey: 'b26d6e45-450d-4193-b592-19ba60a2b36e'
      }
    }
  })
  reff.wrapp = wrapp
  reff.preloader = preloader
  reff.editor = preloader.editor
  reff.ready = false

  return new Promise((resolve, reject) => {
    let tt = setInterval(() => {
      let loader = document.querySelector('.ms-editor .loader')
      if (loader && loader.style.display === 'none') {
        reff.ready = true
        clearInterval(tt)
        resolve(reff)
      }
    })
  })
}

export default {
  name: 'MyScriptJSVueComponent',
  components: {
    Latex
    // 'vue-mathjax': VueMathjax
  },
  data() {
    return {
      showSubmit: false,
      exited: false,
      reff,
      output: '',
      display: '',
      latex: ''
    }
  },
  preload,
  reff,
  beforeCreate () {
    if (!reff.wrapp) {
      preload()
    }
  },
  beforeDestroy() {
    this.exited = true
    this.clear()
  },
  created() {
    // eslint-disable-next-line
    console.log("Created" + this.getDom())
  },
  mounted() {
    window.addEventListener('keyup', (evt) => {
      console.log(evt)
      let esc = evt.keyCode === 27
      if (esc) {
        this.$emit('view', 'main')
      }
    })

    this.$emit('mount', this.getDom())
    // Fired every second, should always be true
    // eslint-disable-next-line
    console.log("Mounted " + this.getDom())

    let wrapp = reff.wrapp
    this.latex = ''
    this.output = ''
    let tt = setInterval(() => {
      if (reff.ready) {
        clearInterval(tt)
        this.$refs.editordom.appendChild(wrapp)
        wrapp.style.position = 'relative'
        wrapp.style.zIndex = '100000'
        this.clear()
        this.getDom().editor.resize()
        setTimeout(() => {
          this.getDom().editor.resize()
          this.clear()
        }, 100)
      }
    })

    wrapp.style.opacity = 1

    // --begin
    // MyScriptJS.register(this.getDom(), {
    //   recognitionParams: {
    //     type: 'MATH',
    //     protocol: 'WEBSOCKET',
    //     apiVersion: 'V4',
    //     server: {
    //       applicationKey: 'fff29db3-b660-4e39-8133-e6d141865cd0',
    //       hmacKey: '2e2c70a6-cedf-41f4-bed4-162207b3f1ab'
    //     }
    //   }
    // })
    // --end

    // let loader = document.querySelector('.ms-editor .loader')
    // if (loader) {
    //   loader.style.display = 'none'
    // }

    // let drawSVG = document.querySelector('.ms-editor svg')
    // if (drawSVG) {
    //   drawSVG.style.display = 'block'
    // }
    window.addEventListener('resize', () => {
      if (this.$refs && this.getDom() && this.getDom().editor) {
        this.getDom().editor.resize()
      }
    })
    this.getDom().addEventListener('converted', (evt) => {
    })
    this.getDom().addEventListener('exported', (evt) => {
      console.log(evt)
      if (evt.detail.exports) {
        const latex = evt.detail.exports['application/x-latex']
        if (latex) {
          this.output = '\\(' + latex + '\\)'
        } else {
          this.output = ' '
        }
        this.latex = latex
        this.$nextTick(() => {
          this.renderOutput()
        })
      } else {
        this.latex = ' '
      }
    })
  },
  methods: {
    getDom () {
      return reff.preloader
      // return this.$refs.editordom
    },
    cleanText() {
      return this.latex.replace('\\(', '').replace('\\)', '').replace('$$', '').replace('$$', '').replace('YourText', '').replace('YourText', '')
    },
    breakLatex() {
      this.latex = `YourText ${'$$' + this.cleanText() + '$$'} YourText`
      this.renderOutput()
    },
    wrapText() {
      this.latex = `YourText ${'\\(' + this.cleanText() + '\\)'} YourText`
      this.renderOutput()
    },
    done() {
      if (this.exited) {
        return
      }
      if (this.latex) {
        this.$emit('done', {
          latex: this.latex
        })
        this.$emit('view', 'mainscreen')
      } else {
        window.alert('Please draw some equation before hitting done.')
      }
    },
    renderOutput() {
      // if (this.latex) {
      //   // this.output = '\\(' + this.latex + '\\)'
      //   // this.output = this.latex
      //   this.$nextTick(() => {
      //     window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, this.$refs['mathJaxEl']], () => {
      //
      //     })
      //   })
      // }
    },
    convert() {
      this.getDom().editor.convert()
    },
    undo() {
      this.getDom().editor.undo()
    },
    redo() {
      this.getDom().editor.redo()
    },
    clear() {
      this.latex = ' '
      this.renderOutput()
      this.getDom().editor.clear()
    },
    onInput() {
      this.output = '\\(' + this.latex + '\\)'
      this.renderOutput()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('./myscript.css');
.full{
  height: 100%;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
#controls{
  height: 100px;
}
.writing-container {
  width: 100%;
  height: calc(100vh - 100px - 41px);
  position: absolute;
  bottom: 0px;
  right: 0px;
  background-color: rgba(0,0,0,0.03);
}
.latex{
  width: 100%;
  height: 100px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: #eeeeee solid 1px;
  border-top: #eeeeee solid 1px;
  background-color: rgba(0,0,0,0.09);
}
.action-tools{
  width: 100%;
  height: 41px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
}
.latex-text{
  height: 41px;
  min-height: 41px;
  width: 160px;
  margin-bottom: 0px;
}
.action-icon{
  font-weight: bold;
  text-decoration: underline;
}

@media screen and (max-width: 500px) {
  #controls{
    height: calc(100px + 45px);
  }
  .writing-container{
    height: calc(100% - 100px - 41px - 45px);
  }
  .latex{
    margin-top: 45px;
    height: calc(100px + 45px);
  }
  .latex-text{
    height: 59px;
    width: 100%;
  }
}
.loader{
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
}
.ms-editor .loader{
  opacity: 0.2;
}
</style>
